// extracted by mini-css-extract-plugin
module.exports = {"seriesRatingWrapper":"Cq","ratingTooltip":"Cr"};